export default __webpack_public_path__ + "static/media/logoMaintenance.68b4e131.png";